<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/inquire_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>活動/投稿查詢</h1>
          <div class="banner-text-line"></div>
          <span>Activity/Contribution Inquire</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content">
        <div class="d-flex justify-content-center">
          <div
            class="list-group list-group-horizontal list-bg list-area rounded-pill"
            id="list-tab"
            role="tablist"
          >
            <a
              class="list-group-item text-center rounded-pill active"
              id="list-activity-list"
              data-toggle="list"
              href="#list-activity"
              role="tab"
              aria-controls="activity"
              >活動查詢</a
            >
          </div>
        </div>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="list-activity"
            role="tabpanel"
            aria-labelledby="list-activity-list"
          >
            <div class="content-title">
              <h2>活動查詢 Activity Enquiry</h2>
              <div class="bread">
                <router-link to="/">
                  <i class="fas fa-home fa-lg"></i>
                </router-link>
                <span>></span>
                活動查詢
              </div>
            </div>
            <div class="content-contact">
              <div class="content-contact-border">
                <div class="input_span">
                  <span>報名代碼<br />Registration code</span>
                  <input
                    type="text"
                    placeholder="請輸入報名代碼"
                    v-model.trim="ActivityNumber"
                    name="activity-number"
                  />
                </div>
                <!-- <div class="input_span">
                  <span>參加姓名</span>
                  <input
                    type="text"
                    placeholder="請填寫參加大名"
                    v-model="searchData.Name"
                    name="activity-name"
                  />
                </div> -->
                <div class="contact-btnBlock">
                  <div class="item">
                    <div
                      class="btn blue-btn islogin"
                      @click="Search('activity')"
                    >
                      <a href="javascript:;">完成送出<br />(Enter)</a>
                    </div>
                  </div>
                  <div class="item">
                    <div class="btn white-btn islogin" @click="Reset">
                      <a href="javascript:;">重新填寫<br />(Rewrite)</a>
                    </div>
                  </div>
                </div>
                <div class="submission-info pt-5" v-if="showInfo">
                  報名資訊
                  <div class="mb-3 pt-3" v-if="participantData.Number">
                    <qrcode-vue :value="qr.value" :size="qr.size" level="H" />
                  </div>
                  <div class="input_span">
                    <span>姓名<br />Name</span>
                    <span>{{ participantData.Name }}</span>
                  </div>
                  <div class="input_span">
                    <span>報名編號<br />Registration code</span>
                    <span>{{ participantData.Number }}</span>
                  </div>
                  <div class="input_span">
                    <span>繳費狀況<br />Payment Status</span>
                    <span>
                      {{
                        participantData.IsPaid
                          ? "已繳費(Paid)"
                          : "未繳費(Unpaid)"
                      }}
                    </span>
                  </div>
                  <div
                    class="input_span"
                    v-if="canSubmission || participantData.IsPaid"
                  >
                    <span v-if="canSubmission">
                      <router-link :to="`/submission/${participantData.Number}`"
                        >前往投稿<br />Abstract registration</router-link
                      >
                    </span>
                    <span v-if="participantData.IsPaid">
                      <a href="#" @click.prevent="goPrint(participantData.Id)"
                        >列印收據</a
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-back">
              <router-link to="/">
                回首頁
                <img src="../assets/images/icon/back_icon.png" alt="回首頁" />
              </router-link>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="list-submit"
            role="tabpanel"
            aria-labelledby="list-submit-list"
          >
            <div class="content-title">
              <h2>投稿查詢</h2>
              <div class="bread">
                <router-link to="/">
                  <i class="fas fa-home fa-lg"></i>
                </router-link>
                <span>></span>
                投稿查詢
              </div>
            </div>
            <div class="content-contact">
              <div class="content-contact-border">
                <div class="input_span">
                  <span>投稿編號</span>
                  <input
                    type="text"
                    placeholder="請輸入投搞編號"
                    v-model.trim="SubmissionNumber"
                    name="Contribution-number"
                  />
                </div>
                <!-- <div class="input_span">
                  <span>投稿姓名</span>
                  <input
                    type="text"
                    placeholder="請填寫投稿大名"
                    v-model="searchData.Name"
                    name="Contribution-name"
                  />
                </div> -->
                <div class="contact-btnBlock">
                  <div class="item">
                    <div
                      class="btn blue-btn islogin"
                      @click="Search('submission')"
                    >
                      <a href="javascript:;">完成送出</a>
                    </div>
                  </div>
                  <div class="item">
                    <div class="btn white-btn islogin" @click="Reset">
                      <a href="javascript:;">重新填寫</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-back">
              <router-link to="/">
                回首頁
                <img src="../assets/images/icon/back_icon.png" alt="回首頁" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import activityApi from '@/assets/api/activity';
import SubmissionApi from '@/assets/api/submission';
import QrcodeVue from 'qrcode.vue';
import BG from '../assets/images/index_bg_big.png';

export default {
  name: 'Inquire',
  components: {
    QrcodeVue,
  },
  data() {
    return {
      BG,
      // searchData: {
      //   Number: '',
      //   Name: '',
      // },
      ActivityNumber: '',
      SubmissionNumber: '',
      participantData: {},
      receiptData: {},
      showInfo: false,
      canSubmission: false,
      qr: {
        value: '',
        size: 200,
      },
    };
  },
  methods: {
    // eslint-disable-next-line consistent-return
    Search(type) {
      const vm = this;
      if (
        (type === 'activity' && vm.ActivityNumber === '')
        || (type === 'submission' && vm.SubmissionNumber === '')
      ) {
        vm.$swal({
          icon: 'warning',
          text: '尚有欄位未填寫!',
          confirmButtonText: '確定',
        });
        // return false;
      } else if (type === 'submission') {
        SubmissionApi.checkSubmission(vm.SubmissionNumber).then((res) => {
          // console.log(res);
          if (res.status === 200) {
            const tmpHtml = `<p>投稿編號：${
              vm.SubmissionNumber
            }</p><p>投稿姓名：${res.data.Data.Name}</p><p>投稿狀態：${
              res.data.DataIsAdmitted ? '審核通過' : '審查中'
            }</p>`;
            vm.$swal({
              html: tmpHtml,
              // icon: 'success',
              // text: 'contribution!',
              confirmButtonText: '確定',
            });
            // return false;
          } else if (res === '請求錯誤,未找到該資源') {
            vm.$swal({
              icon: 'warning',
              text: '查無編號',
              confirmButtonText: '確定',
            });
          } else {
            vm.$swal({
              icon: 'warning',
              text: res.data.Message,
              confirmButtonText: '確定',
            });
          }
        });
      } else if (type === 'activity') {
        vm.$store.dispatch('updateLoading', true);
        activityApi.checkActivity(vm.ActivityNumber).then((res) => {
          vm.$store.dispatch('updateLoading', false);
          // console.log(res);
          if (res.status === 200) {
            vm.participantData = res.data.Data.participant;
            vm.qr.value = vm.participantData.Number;
            vm.receiptData = res.data.Data.receipt;
            vm.checkSubmission();
            if (Object.keys(vm.receiptData).length > 0) {
              vm.showInfo = true;
            } else {
              vm.showInfo = false;
            }
          } else {
            vm.$swal({
              icon: 'warning',
              text: res.data.Message,
              confirmButtonText: '確定',
            });
          }
        });
      }
      // return false;
    },
    checkSubmission() {
      const vm = this;
      activityApi.getTopic(vm.participantData.Id).then((res) => {
        if (res.status === 200) {
          if (res.data.Data.length === 0) {
            vm.canSubmission = false;
          } else {
            vm.canSubmission = true;
          }
        }
      });
    },
    goPrint(id) {
      const vm = this;
      vm.$swal({
        text: '請輸入抬頭，如未輸入則預設為報名名稱',
        input: 'text',
        confirmButtonText: '確定',
      }).then((result) => {
        vm.$swal({
          text: '請輸入統一編號，如未輸入則會顯示空白',
          input: 'text',
          confirmButtonText: '確定',
        }).then((resultID) => {
          let tmpItems = '';
          let tmpResult = '';
          for (let i = 0; i < 7; i += 1) {
            if (i < vm.receiptData.items.length) {
              if (i === 0) {
                tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;border-left: 2px solid #000;padding: 5px;">${
  vm.receiptData.items[i].Title
}</td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;">${
  vm.receiptData.items[i].Amount
}</td>
        <td style="border: 1px solid #000;border-right: 2px solid #000;" rowspan="7">
        <div style="display:flex;justify-content:space-around;align-items: end;">
        <img style="width:50%;" src="${require('@/assets/images/receipt/台灣口腔衛生科學學會大章.png')}" alt="">
        <img src="${require('@/assets/images/receipt/黃曉靈理事長小章.jpg')}" alt="">
        </div>
        </td>
      </tr>`;
              } else {
                tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;border-left: 2px solid #000;padding: 5px;">${vm.receiptData.items[i].Title}</td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;">${vm.receiptData.items[i].Amount}</td>
      </tr>`;
              }
            } else if (i === 6) {
              tmpItems += `<tr>
        <td style="font-size: 14pt;border: 1px solid #000;border-left: 2px solid #000;padding: 5px;text-align: center;" colspan="2">
        合計新台幣：<span style="font-weight: bold;">${vm.ToString(
    vm.receiptData.TotalAmount,
  )}</span>
        </td>
      </tr>`;
            } else {
              tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;border-left: 2px solid #000;padding: 5px;"></td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;height: 24px;"></td>
      </tr>`;
            }
          }
          tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;border-left: 2px solid #000;border-bottom: 2px solid #000;padding: 5px;" colspan="2"></td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;border-bottom: 2px solid #000;border-right: 2px solid #000;padding: 5px;height: 24px;">
        <div style="display:flex;align-items:center;">經辦人：<img style="width: 50px;" src="${require('@/assets/images/receipt/連續章(有框).jpg')}" alt=""></div>
        </td>
      </tr>`;
          tmpResult = `<div>
          <img src="" alt="" style="position: absolute;top: 0;left: 0;margin-top: 18px;width: 180px;display:none;">
  <img src="" alt="" style="position: absolute;top: 0;left: 50%;transform: translateX(-50%);width: 110px;display:none;">
  <h1 style="text-align: center;font-size: 20pt;font-weight: bold;margin-bottom: 5px;">台灣口腔衛生科學學會收費收據</h1>
  <p style="font-size: 12pt;">姓名/抬頭： ${
  result.value ? result.value : vm.receiptData.Name
}</p>
  <div style="display: flex;justify-content: space-between;">
  <p style="font-size: 12pt;">身分證字號/統編： ${
  resultID.value ? resultID.value : ''
}</p>
  <p style="font-size: 12pt;">${vm.receiptData.OrderPayOn}</p>
  </div>
  <table style="width: 100%;border-spacing: 0px;">
    <thead>
      <tr>
      <th style="text-align: center;font-size: 12pt;width: 35%;padding: 5px;border: 1px solid #000;border-left: 2px solid #000;border-top: 2px solid #000;">
      項目
      </th>
      <th style="text-align: center;font-size: 12pt;width: 15%;padding: 5px;border: 1px solid #000;border-top: 2px solid #000;">
      金額
      </th>
      <th style="text-align: center;font-size: 12pt;width: 50%;padding: 5px;border: 1px solid #000;border-top: 2px solid #000;border-right: 2px solid #000;">
      台灣口腔衛生科學學會專用章
      </th>
      </tr>
    </thead>
    <tbody>
      ${tmpItems}
      <tr>
        <td style="font-size: 12pt;padding: 5px;" colspan="2">台灣口腔衛生科學學會</td>
        <td style="text-align: left;font-size: 12pt;padding: 5px;height: 24px;">聯絡資訊</td>
      </tr>
      <tr>
        <td style="font-size: 12pt;padding: 5px;" colspan="2">立案證號：台內社字第0950020618號</td>
        <td style="text-align: left;font-size: 12pt;padding: 5px;height: 24px;">電話：07-3121101轉2159</td>
      </tr>
      <tr>
        <td style="font-size: 12pt;padding: 5px;" colspan="2">統一編號：08919073</td>
        <td style="text-align: left;font-size: 12pt;padding: 5px;height: 24px;">E-Mail:oralhealth.taiwan@gmail.com</td>
      </tr>
      <tr>
        <td style="font-size: 12pt;padding: 5px;" colspan="2"></td>
        <td style="text-align: left;font-size: 12pt;padding: 5px;height: 24px;">會址：高雄市三民區十全一路100號</td>
      </tr>
    </tbody>
    </table>
    `;
          const printWindow = window.open('', '', 'height=400,width=800');
          printWindow.document.write(tmpResult);
          printWindow.document.close();
          setTimeout(() => {
            printWindow.print();
          }, 1000);
        });
      });
    },
    ToString(n) {
      if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
        return '錯誤';
      }
      let returnText = '';

      if (n == 0) {
        returnText = '零元整';
      } else {
        let unit = '仟佰拾億仟佰拾萬仟佰拾元角分';
        let str = '';
        n += '00';

        const indexpoint = n.indexOf('.');

        if (indexpoint >= 0) {
          n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2);
        }

        unit = unit.substr(unit.length - n.length);
        for (let i = 0; i < n.length; i++) {
          str += '零壹貳參肆伍陸柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
        }

        returnText = str
          .replace(/零(仟|佰|拾|角)/g, '零')
          .replace(/(零)+/g, '零')
          .replace(/零(萬|億|元)/g, '$1')
          .replace(/(億)萬|壹(拾)/g, '$1$2')
          .replace(/^元零?|零分/g, '')
          .replace(/元$/g, '元整');
      }
      return returnText;
    },
    Reset() {
      const vm = this;
      vm.ActivityNumber = '';
      vm.SubmissionNumber = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.submission-info {
  display: flex;
  flex-direction: column;
  align-items: center;

  .input_span {
    justify-content: center;
  }
}
</style>
